import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { Status as StatusTypes } from 'src/ts/enums';
import { IEntryReport, IEntryReportData, IRejectedAction } from 'src/ts/interfaces';
import { getApplicantReportPDF, getEntryReportById, getReportsByEntryId } from './services';

export type StateData = {
  getEntryReportById: {
    status: StatusTypes;
    error?: string | null;
    data?: IEntryReportData | null;
  };
  getApplicantReportPDF: {
    status: StatusTypes;
    error?: string | null;
    data?: void;
    fileName?: string;
    preset?: string;
  };
  getReportsByEntryId: {
    status: StatusTypes;
    error?: string | null;
    data?: IEntryReport[];
  };
};

export const initialState: StateData = {
  getEntryReportById: {
    status: StatusTypes.IDLE,
    data: null,
    error: null
  },
  getApplicantReportPDF: {
    status: StatusTypes.IDLE,
    data: undefined,
    error: null,
    fileName: undefined
  },
  getReportsByEntryId: {
    status: StatusTypes.IDLE,
    data: [],
    error: null
  }
};

export const getEntryReportByIdReducer = (builder: ActionReducerMapBuilder<StateData>) => {
  builder.addCase(getEntryReportById.pending, (state: StateData) => {
    state.getEntryReportById.status = StatusTypes.LOADING;
    state.getEntryReportById.error = null;
  });
  builder.addCase(getEntryReportById.rejected, (state: StateData, action: IRejectedAction) => {
    state.getEntryReportById.status = StatusTypes.ERROR;
    state.getEntryReportById.error = action.error?.message;
  });
  builder.addCase(getEntryReportById.fulfilled, (state: StateData, action: PayloadAction<any>) => {
    state.getEntryReportById.status = StatusTypes.SUCCESS;
    state.getEntryReportById.data = action.payload.data;
  });
};

export const getApplicantReportPDFReducer = (builder: ActionReducerMapBuilder<StateData>) => {
  builder.addCase(getApplicantReportPDF.pending, (state: StateData, action: PayloadAction<any>) => {
    state.getApplicantReportPDF.status = StatusTypes.LOADING;
    state.getApplicantReportPDF.error = null;
    state.getApplicantReportPDF.preset = (action as any).meta.arg.preset;
  });
  builder.addCase(getApplicantReportPDF.rejected, (state: StateData, action: IRejectedAction) => {
    state.getApplicantReportPDF.status = StatusTypes.ERROR;
    state.getApplicantReportPDF.error = action.error?.message;
  });
  builder.addCase(
    getApplicantReportPDF.fulfilled,
    (state: StateData, action: PayloadAction<any>) => {
      state.getApplicantReportPDF.status = StatusTypes.SUCCESS;
      state.getApplicantReportPDF.data = action.payload.data;
      state.getApplicantReportPDF.fileName = action.payload.fileName;
      state.getApplicantReportPDF.preset = action.payload.preset;
    }
  );
};

export const getReportsByEntryIdReducer = (builder: ActionReducerMapBuilder<StateData>) => {
  builder.addCase(getReportsByEntryId.pending, (state: StateData) => {
    state.getReportsByEntryId.status = StatusTypes.LOADING;
    state.getReportsByEntryId.error = null;
  });
  builder.addCase(getReportsByEntryId.rejected, (state: StateData, action: IRejectedAction) => {
    state.getReportsByEntryId.status = StatusTypes.ERROR;
    state.getReportsByEntryId.error = action.error?.message;
  });
  builder.addCase(getReportsByEntryId.fulfilled, (state: StateData, action: PayloadAction<any>) => {
    state.getReportsByEntryId.status = StatusTypes.SUCCESS;
    state.getReportsByEntryId.data = action.payload.data;
  });
};
